import { Address } from './api-models';

export const CLAIMING_DIALOG_FOCUS_TIMEOUT = 1;

export enum ClaimingStage {
  STAGE1 = 'GMB_AWAITING_OWNERSHIP',
  STAGE2 = 'GMB_TOKEN_GIVEN',
  STAGE2B = 'STAGE2B',
  STAGE3 = 'GMB_AWAITING_OWNERSHIP_DECISION',
  STAGE4 = 'VERIFICATION_NEEDED',
  STAGE5 = 'STAGE5',
  GIVEN_UP = 'ACTIVATE_BASIC',
  LOST = 'LOST',
  UNDEFINED = 'UNDEFINED',
  WRONG_TYPE = 'WRONG_TYPE', // plus wrongRole flag
}

export const claimingDialogConfig = (languageCode?: string) => ({
  width: '100%',
  height: '100%',
  panelClass: 'claiming-panel',
  disableClose: true,
  data: {
    languageCode,
  },
});

export const CLAIMING_LOCAL_STORAGE_KEY = 'CLAIMING';

export const GermanyCustomerCare = '+49 2119699980';

export enum VerificationScreens {
  GENERAL_VERIFY = 'GENERAL_VERIFY',
  VERIFY_BY = 'VERIFY_BY',
  PERFORM_VERIFY = 'PERFORM_VERIFY',
  CODE_ACCEPTED = 'CODE_ACCEPTED',
  VERIFICATION_ERROR = 'VERIFICATION_ERROR',
  MAXIMUM_ATTEMPTS = 'MAXIMUM_ATTEMPTS',
  SEND_AGAIN = 'SEND_AGAIN',
  ON_ITS_WAY = 'ON_ITS_WAY',
}

export enum GenericVerificationOptions {
  PHONE = 'phone',
  EMAIL = 'email',
  POST = 'post',
}

export interface VerificationBusinessData {
  mailerContactName?: string;
  businessName?: string;
  ADDRESS?: string;
  EMAIL?: string;
  PHONE?: string;
}

export enum OptionsVerificationType {
  EMAIL = 'EMAIL',
  PHONE_CALL = 'PHONE_CALL',
  SMS = 'SMS',
  ADDRESS = 'ADDRESS',
}

export const OptionsOrder = [
  OptionsVerificationType.SMS,
  OptionsVerificationType.PHONE_CALL,
  OptionsVerificationType.EMAIL,
  OptionsVerificationType.ADDRESS,
];

export interface FetchVerificationResponse {
  isPending?: boolean;
  selectedOption: string;
  options: VerificationOptions[];
}

export interface VerificationOptions {
  verificationMethod: OptionsVerificationType;
  emailData?: EmailData;
  phoneNumber?: string;
  addressData?: AddressData;
}

export interface VerificationModel {
  VERIFY_BY: {
    title: string;
    subtitle: string;
    options: Record<OptionsVerificationType, { text: any; option: OptionsVerificationType }[]>;
    alreadyHaveCodeButton: string;
    changeMethodMessage: string;
    changeMethodButton: string;
  };
  PERFORM_VERIFY: {
    title: string;
    subtitle: string;
    confirmButton: string;
    wrongCodeText: string;
    codeNotReceivedButton: string;
  };
  CODE_ACCEPTED: {
    title: string;
    imageURL: string;
    message: string;
    button: string;
  };
  VERIFICATION_ERROR: {
    title: string;
    imageURL: string;
    message: string;
    button: string;
  };
  SEND_AGAIN: {
    title: string;
    subtitle: string;
    sendAgainButton: string;
    codeReceivedButton: string;
    changeMethodMessage: string;
    changeMethodButton: string;
  };
  MAXIMUM_ATTEMPTS: {
    title: string;
    imageURL: string;
    message: string;
    sendAgainButton: string;
    changeMethodMessage: string;
    changeMethodButton: string;
  };
  ON_ITS_WAY: {
    title: string;
    imageURL: string;
    message: string;
    button: string;
  };
}

export interface ClaimingBottomsheetText {
  question: string;
  text: string;
  buttonText: string;
}

export interface VerificationInitModel {
  title: string;
  subtitle: string;
  availableOptions: VerificationOptionModel[];
}

export interface VerificationOptionModel {
  buttonText: string;
  advice: string;
  option: OptionsVerificationType;
  imageURL: string;
}

export enum AwaitingOwnershipStatus {
  TRUE = 'GMB_AWAITING_OWNERSHIP',
  FALSE = 'NO',
  WRONG_TYPE = 'WRONG_TYPE',
  REQUESTED = 'REQUESTED',
}

export enum ClaimingDialogActions {
  CONTINUE = 'CONTINUE',
  SET_OWNERSHIP_DONE = 'SET_OWNERSHIP_DONE',
  OPEN_CLAIMING_DIALOG = 'OPEN_CLAIMING_DIALOG',
  CHECK_STATE = 'CHECK_STATE',
}

export interface FetchVerificationRequest {
  languageCode: string;
}

export interface FetchVerificationResponse {
  isPending?: boolean;
  selectedOption: string;
  options: VerificationOptions[];
}

export enum VerificationStatus {
  FECTHING_VERI = 'FECTHING_DATA',
  INITIATE_VERI = 'INITIATE_VERI',
  FINISH_VERI = 'FINISH_VERI',
}

export interface VerificationOptions {
  verificationMethod: OptionsVerificationType;
  emailData?: EmailData;
  phoneData?: PhoneData;
  addressData?: AddressData;
}

export interface EmailData {
  domainName: string;
  userName: string;
  isUserNameEditable: boolean;
}

export interface PhoneData {
  phoneNumber: string;
}

export interface AddressData {
  businessName: string;
  address: Address;
}
